import { SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';

const BASE = '/api/snapdocs/closings';

export class SnapdocsClosingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  #getClosingResource(resource, { applicationId, companyId }) {
    return this.#http.get(`${BASE}/${applicationId}/${resource}`, {
      ...SKIP_FORBIDDEN_RESPONSE_CONFIG,
      params: { companyId },
    });
  }

  getStatus(params) {
    return this.#getClosingResource('status', params);
  }

  getAppointment(params) {
    return this.#getClosingResource('appointment', params);
  }

  getBorrowers(params) {
    return this.#getClosingResource('borrowers', params);
  }

  getNotary(params) {
    return this.#getClosingResource('notary', params);
  }

  getQualityControl(params) {
    return this.#getClosingResource('quality-control', params);
  }

  getComments(params) {
    return this.#getClosingResource('comments', params);
  }

  getAudit(params) {
    return this.#getClosingResource('audit', params);
  }
}
